/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Double_Pumps_PermutationInputs */



/**
* | output |
* | --- |
* | "Double pump changeover" |
*
* @param {Double_Pumps_PermutationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const double_pumps_permutation = /** @type {((inputs?: Double_Pumps_PermutationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Double_Pumps_PermutationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Double pump changeover")
	return /** @type {LocalizedString} */ ("Permutation des pompes doubles")
});